import { Page } from "../../Components/Page/Page.component";
import { GroceriesTable } from "./Groceries.table";

export const GroceriesPage = () => {
  return (
    <Page title="Groceries">
      <GroceriesTable />
    </Page>
  );
};
